import R from 'ramda';
import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = {
  location: null,
  uniID: null,

  cityLocalized: '',
  countryLocalized: '',

  latitude: null,
  longitude: null,
  zoomLevel: null,
  minZoomLevel: null,

  bounds: {
    leftLng: null,
    rightLng: null,
    topLat: null,
    bottomLat: null,
  },

  infoWindowFor: null,
  highlightedUniverId: null, // FIXME
  highlightedRoomId: null, // FIXME

  scrollwheel: true,

  // isOutdated makes no sense when isAutoSearchEnabled is true.
  isAutoSearchEnabled: true,
  isMobileMapOpen: false,
};

export default handleActions(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      ...R.pick(['minZoomLevel', 'cityLocalized', 'countryLocalized'], payload),
      latitude: state.latitude ? state.latitude : payload.latitude,
      longitude: state.longitude ? state.longitude : payload.longitude,
      zoomLevel: state.zoomLevel ? state.zoomLevel : payload.zoomLevel,
      // If auto-search is disabled results are now up to date.
      ...(state.isAutoSearchEnabled ? {} : { isOutdated: false }),
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { location, uniID } },
    ) => ({
      ...state,
      location,
      uniID,
    }),

    [Actions.HIGHLIGHT_ROOM]: (state, { payload }) =>
      R.assoc('highlightedRoomId', payload, state),
    [Actions.UNHIGHLIGHT_ROOM]: state =>
      R.assoc('highlightedRoomId', null, state),

    [Actions.HIGHLIGHT_INFO_WINDOW]: state => ({
      ...state,
      scrollwheel: false,
    }),
    [Actions.UNHIGHLIGHT_INFO_WINDOW]: state => ({
      ...state,
      scrollwheel: true,
    }),
    [Actions.UPDATE_MAP]: (
      state,
      { payload: { center, zoom, marginBounds } },
    ) => ({
      ...state,
      latitude: center.lat,
      longitude: center.lng,
      zoomLevel: zoom,
      bounds: {
        leftLng: marginBounds.nw.lng,
        rightLng: marginBounds.se.lng,
        topLat: marginBounds.nw.lat,
        bottomLat: marginBounds.se.lat,
      },
      // If auto-search is disabled results are now outdated.
      ...(state.isAutoSearchEnabled ? {} : { isOutdated: true }),
    }),

    [Actions.DISABLE_MAP]: state => ({
      ...state,
      latitude: initialState.latitude,
      longitude: initialState.longitude,
      zoomLevel: initialState.zoomLevel,
      bounds: initialState.bounds,
    }),

    [Actions.TOGGLE_MAP_AUTO_SEARCH]: (state, { payload: value }) => ({
      ...state,
      isAutoSearchEnabled: value,
      ...(value ? {} : { isOutdated: false }),
    }),

    [Actions.TOGGLE_MOBILE_MAP]: state => ({
      ...state,
      isMobileMapOpen: !state.isMobileMapOpen,
    }),
  },
  initialState,
);
